import { render, staticRenderFns } from "./Home.vue?vue&type=template&id=3919b983&scoped=true&"
import script from "./js/home.js?vue&type=script&lang=js&"
export * from "./js/home.js?vue&type=script&lang=js&"
import style0 from "./Home.vue?vue&type=style&index=0&id=3919b983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3919b983",
  null
  
)

export default component.exports